import {  Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { InstructionsComponent } from '../instructions/instructions.component';
import { MatDialog } from '@angular/material/dialog';
import { SkippedUserComponent } from './skipped-user/skipped-user.component';
import { PrioritizeUserComponent } from './prioritize-user/prioritize-user.component';
import { AiService } from '../../service/ai.service';
import { SnackService } from '../../service/snack.service';
import { FullPersonaComponent } from './full-persona/full-persona.component';
import { ReportService } from '../../service/report.service';
import { TrackService } from '../../service/track.service';


@Component({
  selector: 'app-user-tinder',
  standalone: false,
  templateUrl: './user-tinder.component.html',
  styleUrl: './user-tinder.component.scss'
})
export class UserTinderComponent implements OnChanges {
  // Injections
  trackservice = inject(TrackService);
  aiService = inject(AiService);
  dialog = inject(MatDialog);
  snack = inject(SnackService);
  report = inject(ReportService);

  // Inputs
  @Input() thisStepCount: number = 0;
  @Input() totalStepCount: number = 0;
  @Input() stepId: any;
  @Input() streamId: any;
  @Input() roundId: any;
  @Input() step: any;
  @Input() runClosingPrompt: boolean = false;
  @Input() initialReady: boolean = false;

  // Outputs
  @Output() nextStreamStepDisabledStatus: EventEmitter<boolean> = new EventEmitter(true);
  @Output() closingPromptReady: EventEmitter<{ "input": string, "type": string } | undefined> = new EventEmitter(undefined);

  // Variables
  nextBtnDisabledStatus: boolean = true;
  personas: any[] = [];
  imageNumber: number = 1;
  personaImageUrl: string = 'url(images/default-persona.png)';
  stepIsRunning: boolean = false;
  loading: boolean = false;
  makeChoise: boolean = false;
  shoeMainPersona: boolean = false;

  // Objects
  positivePersonas: any[] = [];
  negativePersonas: any[] = [];
  skippedPersonas: any[] = [];
  personaQueue: any[] = []

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes["runClosingPrompt"] && changes["runClosingPrompt"].currentValue) {
      if (changes["runClosingPrompt"].currentValue === true) {
        this.saveResult();
      }
    }
    if (changes["initialReady"] && changes["initialReady"].currentValue === true) {

      this.stepIsRunning = true;
      let c = await this.trackservice.loadComHistory(this.stepId, this.roundId)
      if (c) {
        this.positivePersonas = c.positivePersonas;
        this.negativePersonas = c.negativePersonas;
        this.skippedPersonas = c.skippedPersonas;
        this.nextStreamStepDisabledStatus.emit(false);
        this.shoeMainPersona = true;
      } else {
        this.loadInitialPersonas();
      }
    }

  }

  async showFUllPersona() {
    let dia = await this.dialog.open(FullPersonaComponent, {
      data: { persona: this.personaQueue[0] }
    });


  }
  async saveResult() {
    let content: any = this.positivePersonas[0];
    content.created = new Date().getTime();
    if (content.length == 0) {
      alert("Please select at least one positive persona.");
      return;
    }
    if (this.positivePersonas.length > 1 && this.makeChoise === false) {
      this.openPriorizePersonas();
      return;
    }

    let communicationHistory = {
      positivePersonas: this.positivePersonas,
      negativePersonas: this.negativePersonas,
      skippedPersonas: this.skippedPersonas
    }

    this.trackservice.saveComHistory(this.stepId, this.roundId, communicationHistory);
    this.closingPromptReady.emit({ "input": this.positivePersonas[0], "type": "save-only" });
  }
  async restartAgain() {
    let confirmResult = await confirm('Do you really want to reset your Data? All Files and Memory-Data will be deleted.')
    if (!confirmResult) {
      return;
    }
    let files = await this.trackservice.trackFiles.getValue();
    for await (let file of files) {
      if (file.roundId == this.roundId && file.stepId == this.stepId) {
        await this.trackservice.deleteFileFromTrackResult(this.roundId, file.id, file.fileName)
      }
    }
    this.positivePersonas = [];
    this.negativePersonas = [];
    this.skippedPersonas = [];
    this.trackservice.saveComHistory(this.stepId, this.roundId, null);
    this.loadInitialPersonas()
    this.report.saveReport(this.roundId, 'Reset & Start Again')
  }

  async loadPersonas() {
    this.imageNumber = Math.floor(Math.random() * 2) + 1;
    let promptType = 'INITIALIZE_STEP_PROMPT';
    let storage = await this.trackservice.trackResults.getValue();
    console.log("Storage", storage);


    let input = `<BASIC IDEA>\n`
    // Filter Storage for Basic Idea : "MMUT2vQla"
    for await (let r of storage) {
      let res = await r.stepResults.find((result) => result.stepId === "MMUT2vQla");
      if (res) {
        input += JSON.stringify(res.result);
      }
    }


    this.loading = true;
    this.stepIsRunning = true;
    let result = await this.aiService.getAiResponse(this.streamId, this.stepId, input, promptType, 0, this.roundId);
    this.stepIsRunning = false;
    this.loading = false;
    let counter = 0;

    while ((result === false || result.promptResult.length === 0 || result.promptResult.length > 10) && counter < 3) {
      counter++;
      this.loading = true;
      console.log("Error in AI response ==> RESTART: ", result.promptResult);
      result = await this.aiService.getAiResponse(this.streamId, this.stepId, JSON.stringify(storage), promptType, 0, this.roundId);
      this.loading = false;
    }
    let personasArray: any[] = [];
    for await (const persona of result.promptResult) {
      if (typeof persona === 'object' && typeof persona !== 'string') {
        personasArray.push(persona);
      }
    }
    personasArray.forEach((persona: any) => {
      let gender = "w";
      if (!persona?.demographics?.gender || persona?.demographics?.gender == 'non-binary') gender = "w";
      if (persona?.demographics?.gender == 'Male') gender = "m";
      if (persona?.demographics?.gender == 'm') gender = "m";
      if (persona?.demographics?.gender == 'Female') gender = "w";

      if (persona.sinus_milieu) {
        persona.sinus_milieuse = persona.sinus_milieu;
        delete persona.sinus_milieu;
      }
      if (persona.sinus_milieus) {
        persona.sinus_milieuse = persona.sinus_milieus;
        delete persona.sinus_milieus;
      }

      if (persona.sinus_milieuse) {
        persona.image = `background-image:url('personas/${persona.sinus_milieuse.toLowerCase()}/${gender}${this.imageNumber}.png')`;
      } else {
        persona.sinus_milieuse = "default";
        persona.image = 'background-image:url(images/default-persona.png)'
      }

    });

    return personasArray;
  }

  // async generateMore() {
  //   // let personasArray = await this.loadPersonas()
  //   // this.personaQueue = [...this.personaQueue, ...personasArray];
  //   // this.personas = personasArray;
  // }

  async loadInitialPersonas() {
    let personasArray = await this.loadPersonas()
    this.personaQueue = personasArray || [];
    this.personas = personasArray || [];
  }

  async openInstructions() {
    let dia = await this.dialog.open(InstructionsComponent, {
      data: { for: 'userTinder' },
      width: '500px'
    });

    dia.afterClosed().subscribe((result: any) => { })
  }
  async openPriorizePersonas() {
    this.shoeMainPersona = true;
    let dia = await this.dialog.open(PrioritizeUserComponent, {
      data: this.positivePersonas,
      width: '500px'
    });

    dia.afterClosed().subscribe((result: any) => {
      if (result) {
        // Sort positivePersonas that the result is the first one
        this.positivePersonas = [result, ...this.positivePersonas.filter(p => p.name !== result.name)];
        this.makeChoise = true;
        this.saveResult();
      }
    });

  }

  matchPersona() {
    this.positivePersonas.push(this.personaQueue[0]);
    this.personaQueue = this.personaQueue.filter((p) => p !== this.personaQueue[0]);
    if (this.personaQueue.length == 0 && this.positivePersonas.length > 0) {
      this.nextStreamStepDisabledStatus.emit(false);
    }
  }

  noMatchPersona() {
    this.negativePersonas.push(this.personaQueue[0]);
    this.personaQueue = this.personaQueue.filter((p) => p !== this.personaQueue[0]);
    if (this.personaQueue.length == 0 && this.positivePersonas.length > 0) {
      this.nextStreamStepDisabledStatus.emit(false);
    }
  }

  skipPersona() {
    this.skippedPersonas.push(this.personaQueue[0]);
    this.personaQueue = this.personaQueue.filter((p) => p !== this.personaQueue[0]);
    if (this.personaQueue.length == 0 && this.positivePersonas.length > 0) {
      this.nextStreamStepDisabledStatus.emit(false);
    }
  }

  removeSelection(persona: any) {
    console.log('Removing selection for persona:', persona);

    this.positivePersonas = this.positivePersonas.filter((p) => p !== persona);
    this.negativePersonas = this.negativePersonas.filter((p) => p !== persona);
    // add persona to first position not end
    this.personaQueue.unshift(persona);
    this.nextStreamStepDisabledStatus.emit(true);
    // this.personaQueue.push(persona);
  }

  async showSkipped() {
    let dia = await this.dialog.open(SkippedUserComponent, {
      data: { personas: this.skippedPersonas }
    })

    dia.afterClosed().subscribe((result) => {
      if (result) {
        result.positive.forEach((p: any) => {
          this.positivePersonas.push(p)
        });
        result.negative.forEach((p: any) => {
          this.negativePersonas.push(p)
        });
        this.skippedPersonas = result.skipped
      }
    })
  }


}
